module.exports = __webpack_public_path__ + "static/media/mystyles.fdd7fcd8.scss";


//////////////////
// WEBPACK FOOTER
// ./src/styles/mystyles.scss
// module id = 26
// module chunks = 0